var _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Icon_Error",
    "data-name": "Icon Error",
    transform: "translate(0 18)",
    fill: "#6a0200",
    fontSize: 20,
    fontFamily: "FontAwesome5Pro-Light, 'Font Awesome \\\\\\\\35  Pro'",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uF057"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/iconError.f1aca5f188b10f1848caa5b6d57f9808.svg";
export { ForwardRef as ReactComponent };